import theme from '../../../../../lib/theme';
import { PanelBlockProps } from './PanelBlock';

const { colors, corners, scale, layouts, media, layers } = theme;

export default ({
  blockIndex,
  block: {
    brand = 'sas',
    reverse,
    backgroundColor = 'transparent',
    imageAlign,
  },
}: PanelBlockProps) => ({
  wrapper: {
    marginTop: blockIndex === 0 ? `-${scale.s} !important` : 0,
  },

  container: {
    ...layouts.column,

    position: 'relative',
    alignItems: 'center',
    padding: `0 ${scale.xs}`,
    backgroundColor: colors[backgroundColor] || colors[brand][backgroundColor],
    minHeight: '60vh',

    '&:after':
      backgroundColor !== 'transparent' && !backgroundColor.endsWith('grey')
        ? {
            content: `' '`,
            display: 'block',
            position: 'absolute',
            zIndex: 4,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            backgroundImage: `linear-gradient(180deg, ${colors[brand][backgroundColor]} 33px, rgba(255,255,255,0) 133px)`,
          }
        : {},
  },

  row: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('l'),

    position: 'relative',
    justifyContent: 'space-between',
    flex: 1,
    alignItems: 'center',
    textAlign: 'center',

    '&:after':
      backgroundColor !== 'transparent'
        ? {
            content: `' '`,
            display: 'block',
            position: 'absolute',
            zIndex: 3,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            opacity: 0.4,
            backgroundSize: 'cover',
            backgroundPosition: 'top center',
            backgroundRepeat: 'no-repeat',
            backgroundImage: `url('https://images.startsat60.com/frontend/collection/panel-60-transparent.svg')`,
          }
        : {},

    [media.l.up]: {
      textAlign: 'left',
      alignItems: 'stretch',
      flexDirection: reverse ? 'row-reverse' : 'row',

      '& > *': {
        margin: reverse ? `0 0 0 ${scale.l}` : `0 ${scale.l} 0 0`,
      },

      '& > *:last-child': {
        margin: 0,
      },

      '&:after':
        backgroundColor !== 'transparent' && !backgroundColor.endsWith('grey')
          ? {
              backgroundPosition: 'bottom center',
            }
          : {},
    },
  },

  textContainer: {
    ...layouts.container('m'),
    ...layouts.spacedColumn('m'),

    position: 'relative',
    zIndex: 5,
    paddingTop: scale.l,
    alignItems: 'center',
    justifyContent: 'center',

    [media.l.up]: {
      alignItems: 'flex-start',
      paddingBottom: scale.l,
    },
  },

  text: {
    ...layouts.spacedColumn('xs'),

    '& ul': {
      textAlign: 'left',
    },
  },

  textAndButton: {
    ...layouts.spacedColumn('m'),

    alignItems: 'center',

    [media.l.up]: {
      alignItems: 'flex-start',
    },
  },

  image: {
    width: 280,

    [media.s.up]: {
      width: 320,
    },

    [media.m.up]: {
      width: 550,
    },
  },

  imageContainer: {
    ...layouts.row,

    position: 'relative',
    zIndex: 5,
    flex: 1,
    alignItems:
      imageAlign === 'top'
        ? 'flex-start'
        : imageAlign === 'bottom'
        ? 'flex-end'
        : 'center',
  },

  topButton: {
    position: 'absolute',
    zIndex: 5,
    top: 0,
    left: '50%',
    transform: 'translate(-50%, -50%)',
    whiteSpace: 'nowrap',
  },

  logos: {
    ...layouts.column,

    alignItems: 'center',
    padding: `${scale.l} ${scale.xs} ${scale.m}`,
    backgroundColor: colors.light_grey,
  },

  logosContainer: {
    ...layouts.container('l'),
    ...layouts.spacedColumn('s'),
  },

  logoWrap: {
    ...layouts.row,

    overflowX: 'scroll',

    '& > *': {
      ...layouts.column,

      justifyContent: 'center',
      alignItems: 'center',
      marginRight: scale.m,
      marginBottom: scale.s,
    },

    [media.l.up]: {
      overflowX: 'hidden',
      flexWrap: 'wrap',
    },
  },

  joinWrapper: {
    ...layouts.row,

    paddingLeft: scale.xs,
    borderRadius: corners.f,
    backgroundColor: colors.white,
    height: 50,
  },

  joinInput: {
    color: colors.dark_grey,
    height: 50,
    border: 'none',
    outline: 'none',
  },

  joinButtonText: {
    whiteSpace: 'nowrap',

    [media.m.up]: {
      display: 'inline-block',
    },
  },

  buttonIcon: {
    marginLeft: scale.xxxxs,
  },

  buttons: {
    ...layouts.spacedRow('s'),

    flexWrap: 'wrap',
  },
});
